<template>
  <div>
    <div
      v-if="!loaded || l_day_deletion"
      class="empty_map"
      style="text-align: center"
    >
      <v-progress-circular
        :indeterminate="true"
        size="50"
        style="margin-top: 125px"
      ></v-progress-circular>
    </div>
    <div v-else>
      <div v-if="currentView === 'points'">
        <GmapMap
          ref="mapRefPoints"
          v-if="locations.length !== 0"
          :center="map_center"
          :zoom="map_zoom"
          map-type-id="roadmap"
          :options="mapOptions"
          style="width: calc(100% + 2 * 12px); height: 400px; margin: -12px"
        >
          <gmap-cluster>
            <GmapMarker
              v-for="location in pointLocations"
              :position="google && new google.maps.LatLng(location.location)"
              :key="location.id"
            ></GmapMarker>
          </gmap-cluster>
        </GmapMap>
        <div class="empty_map" v-else></div>
      </div>
      <div v-else>
        <GmapMap
          ref="mapRefGrouped"
          v-if="locations.length !== 0"
          :center="map_center"
          :zoom="map_zoom"
          map-type-id="roadmap"
          :options="mapOptions"
          style="width: calc(100% + 2 * 12px); height: 400px; margin: -12px"
        >
          <GmapPolyline
            :path.sync="path"
            :options="{ strokeColor: '#000' }"
          ></GmapPolyline>
        </GmapMap>
        <div class="empty_map" v-else></div>
      </div>
    </div>
    <v-layout style="margin: 25px 0 30px 0" row>
      <v-flex sm8 xs8 style="text-align: left">
        <h3>
          {{ view_date }}
          <i
            style="margin-left: 5px; cursor: pointer"
            @click="openDateSelect"
            class="fad fa-calendar-day"
          ></i>
        </h3>
      </v-flex>
      <v-flex sm4 xs4 style="text-align: right">
        <v-btn @click="dayBack" text>
          <i class="fal fa-chevron-left"></i>
        </v-btn>
        <v-btn
          @click="dayForward"
          :disabled="today_date === programmatically_date"
          text
        >
          <i class="fal fa-chevron-right"></i>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-row v-if="loaded && locations.length > 0" class="mb-6 mx-0">
      <v-col cols="6" sm="3" class="pa-1" v-if="totalDistance > 0">
        <v-card outlined height="100%">
          <v-card-text style="text-align: center; padding: 12px;">
            <div style="font-size: 11px; color: grey; text-transform: uppercase; font-weight: bold;">{{ $t("timeline.total_distance") }}</div>
            <div style="font-size: 22px; font-weight: bold; margin-top: 4px; color: var(--v-primary-base);">
              <i class="fad fa-route" style="margin-right: 6px;"></i>{{ totalDistance }} <span style="font-size: 14px; font-weight: normal; color: grey;">{{ $t("timeline.km") }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" sm="3" class="pa-1">
        <v-card outlined height="100%">
          <v-card-text style="text-align: center; padding: 12px;">
            <div style="font-size: 11px; color: grey; text-transform: uppercase; font-weight: bold;">{{ $t("timeline.places_visited") }}</div>
            <div style="font-size: 22px; font-weight: bold; margin-top: 4px; color: var(--v-primary-base);">
              <i class="fad fa-map-marker-alt" style="margin-right: 6px;"></i>{{ locations_filtered.length }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" sm="3" class="pa-1">
        <v-card outlined height="100%">
          <v-card-text style="text-align: center; padding: 12px;">
            <div style="font-size: 11px; color: grey; text-transform: uppercase; font-weight: bold;">{{ $t("timeline.points_recorded") }}</div>
            <div style="font-size: 22px; font-weight: bold; margin-top: 4px; color: var(--v-primary-base);">
              <i class="fad fa-map-pin" style="margin-right: 6px;"></i>{{ locations.length }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" sm="3" class="pa-1" v-if="primaryCity">
        <v-card outlined height="100%" @click="additionalCitiesCount > 0 ? d_cities_dialog = true : null" :style="additionalCitiesCount > 0 ? 'cursor: pointer' : ''" :ripple="additionalCitiesCount > 0">
          <v-card-text style="text-align: center; padding: 12px;">
            <div style="font-size: 11px; color: grey; text-transform: uppercase; font-weight: bold;">{{ $t("timeline.cities_visited") }}</div>
            <div style="font-size: 16px; font-weight: bold; margin-top: 4px; color: var(--v-primary-base); white-space: normal;">
              <i class="fad fa-city" style="margin-right: 6px;"></i>{{ primaryCity }}
            </div>
            <div v-if="additionalCitiesCount > 0" style="font-size: 11px; color: grey; margin-top: 2px;">
              + {{ additionalCitiesCount }} {{ $t("timeline.more_cities") }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div v-if="!loaded || l_day_deletion" style="text-align: center">
      <v-progress-circular
        v-if="!loaded"
        :indeterminate="true"
        size="70"
        style="margin-top: 30px"
      ></v-progress-circular>
    </div>
    <div v-else>
      <div v-if="locations.length === 0" style="text-align: center">
        <p>{{ $t("timeline.no_data_recorded_for_this_date_yet") }}</p>
        <p>{{ $t("timeline.install_the_companion") }}</p>
      </div>
      <div v-else>
        <v-timeline
          dense
          align-top
          v-if="currentView === 'grouped'"
        >
          <PointGroup
            v-for="(location, index) in locations_filtered"
            :key="location.id"
            :location="location"
            :full_locations="locations_filtered"
            :index="index"
            :editMode="editMode"
            :isRange="endDate !== null"
            @delete="deletePoint"
            @edit="editPoint"
          ></PointGroup>
        </v-timeline>
        <v-timeline dense align-top v-else>
          <PointSingle
            v-for="(location, index) in locations"
            :key="location.id"
            :location="location"
            :index="index"
            :editMode="editMode"
            :isRange="endDate !== null"
            @delete="deletePoint"
            @edit="editPoint"
          ></PointSingle>
        </v-timeline>
        <div class="timeline-actions">
          <v-btn
            :to="`/timeline_month/${programmatically_date.substring(0, 7)}`"
            color="default"
            text
          >
            <i class="fal fa-calendar-alt" style="margin-right: 5px"></i>
            {{ $t("timeline.monthly_view") }}
          </v-btn>
          <v-btn
            :to="`/timeline_year/${programmatically_date.substring(0, 4)}`"
            color="default"
            text
          >
            <i class="fal fa-calendar" style="margin-right: 5px"></i>
            {{ $t("timeline.yearly_view") }}
          </v-btn>
          <v-btn
            @click="switchView"
            color="default"
            text
          >
            <i
              class="fal"
              :class="
                currentView == 'grouped' ? 'fa-map-marker-alt' : 'fa-layer-group'
              "
              style="margin-right: 5px"
            ></i>
            {{ $t(currentView == "points" ? "timeline.switch_to_group_view" : "timeline.switch_to_point_view") }}
          </v-btn>
          <v-btn
            @click="editMode = !editMode"
            :color="editMode ? 'primary' : 'default'"
            text
          >
            <i class="fal fa-edit" style="margin-right: 5px"></i> {{ $t(editMode ? 'timeline.exit_edit_mode' : 'timeline.enter_edit_mode') }}
          </v-btn>
          <v-btn
            v-if="editMode"
            @click="deleteDay"
            color="error"
            text
          >
            <i class="fal fa-trash" style="margin-right: 5px"></i> {{ $t("timeline.delete_this_day") }}
          </v-btn>
          <v-btn
            v-if="editMode"
            @click="retrieveMissingAddresses"
            color="primary"
            text
          >
            <i class="fal fa-map-marked-alt" style="margin-right: 5px"></i> {{ $t("timeline.retrieve_missing_addresses") }}
          </v-btn>
        </div>
      </div>
      <v-dialog v-model="d_date_select" max-width="400">
        <v-card>
          <v-card-title class="headline">{{
            $t("today.select_date")
          }}</v-card-title>
          <v-card-text style="text-align: center">
            <v-date-picker
              range
              :allowed-dates="allowedDates"
              :first-day-of-week="1"
              :picker-date.sync="pickerDate"
              :events="filled_dates"
              v-model="selectedDates"
            ></v-date-picker>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="d_date_select = false">{{ $t("general.cancel") }}</v-btn>
            <v-btn color="primary" text @click="applyDateSelection">{{ $t("timeline.show_range") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="d_edit_location" max-width="400">
        <v-card>
          <v-card-title class="headline">{{ $t("timeline.edit_location") }}</v-card-title>
          <v-card-text>
            <v-text-field v-model="edit_location_address" :label="$t('timeline.address')"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="d_edit_location = false">{{ $t("general.cancel") }}</v-btn>
            <v-btn color="primary" text @click="saveLocationEdit">{{ $t("general.save") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="d_cities_dialog" max-width="400">
        <v-card>
          <v-card-title class="headline">{{ $t("timeline.cities_visited") }}</v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item v-for="(city, index) in allCities" :key="index">
                <v-list-item-avatar>
                  <v-icon class="primary white--text">fas fa-city</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ city.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ city.count }} {{ $t("timeline.points_recorded") }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="d_cities_dialog = false">{{ $t("general.close") || 'Close' }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="refetchProgress.active" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">{{ $t("timeline.notification.retrieving_addresses") || 'Retrieving addresses...' }}</v-card-title>
          <v-card-text>
            <div class="mb-2 text-center" style="font-size: 16px; font-weight: bold;">{{ refetchProgress.current }} / {{ refetchProgress.total }}</div>
            <v-progress-linear
              :value="(refetchProgress.current / refetchProgress.total) * 100"
              height="20"
              color="primary"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { storage } from "../schmucklicloud";
import Location from "../logic/Location";

import PointGroup from "../components/timeline/PointGroup";
import PointSingle from "../components/timeline/PointSingle";
import { Notifications } from "../notification";

import { gmapApi } from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import { getMapOptions } from "../mapStyles";
Vue.component("GmapCluster", GmapCluster);

export default {
  data() {
    return {
      date: new Date(),
      endDate: null,
      d_date_select: false,
      loaded: false,
      editMode: false,
      d_edit_location: false,
      edit_location_item: null,
      edit_location_address: "",

      currentView: window.localStorage.getItem("timeline_view") || "grouped",

      totalDistance: 0,
      primaryCity: null,
      additionalCitiesCount: 0,
      allCities: [],
      d_cities_dialog: false,

      locations: [],
      locations_filtered: [],
      path: [],

      pickerDate: null,
      filled_dates: [],
      already_crawled_months: [],
      selectedDates: [],

      l_day_deletion: false,
      refetchProgress: { active: false, current: 0, total: 0 },
    };
  },
  mounted() {
    var current_date = this.$route.params.date;
    var end_date = this.$route.params.enddate;
    if (current_date !== undefined) {
      this.date = new Date(current_date);
      if (end_date !== undefined) {
        this.endDate = new Date(end_date);
      }
    } else {
      this.updateUrl();
    }

    this.load();
  },
  computed: {
    google: gmapApi,
    mapOptions() {
      return getMapOptions(this.$vuetify.theme.dark);
    },
    map_zoom() {
      return this.getZoomLevel(this.path);
    },
    map_center() {
      return this.getCenterFromCoordinates(this.path);
    },
    today_date() {
      var today = new Date();
      return (
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1 + "").padStart(2, "0") +
        "-" +
        (today.getDate() + "").padStart(2, "0")
      );
    },
    programmatically_date() {
      return (
        this.date.getFullYear() +
        "-" +
        (this.date.getMonth() + 1 + "").padStart(2, "0") +
        "-" +
        (this.date.getDate() + "").padStart(2, "0")
      );
    },
    programmatically_end_date() {
      if (!this.endDate) return null;
      return (
        this.endDate.getFullYear() +
        "-" +
        (this.endDate.getMonth() + 1 + "").padStart(2, "0") +
        "-" +
        (this.endDate.getDate() + "").padStart(2, "0")
      );
    },
    view_date() {
      var months = [
        this.$t("general.month.january"),
        this.$t("general.month.february"),
        this.$t("general.month.march"),
        this.$t("general.month.april"),
        this.$t("general.month.may"),
        this.$t("general.month.june"),
        this.$t("general.month.july"),
        this.$t("general.month.august"),
        this.$t("general.month.september"),
        this.$t("general.month.october"),
        this.$t("general.month.november"),
        this.$t("general.month.december"),
      ];

      var day_of_week = [
        this.$t("general.day_of_week.sunday"),
        this.$t("general.day_of_week.monday"),
        this.$t("general.day_of_week.tuesday"),
        this.$t("general.day_of_week.wednesday"),
        this.$t("general.day_of_week.thursday"),
        this.$t("general.day_of_week.friday"),
        this.$t("general.day_of_week.saturday"),
      ];

      var startStr = day_of_week[this.date.getDay()] +
        ", " +
        this.date.getDate() +
        ". " +
        months[this.date.getMonth()] +
        " " +
        this.date.getFullYear();
        
      if (this.endDate) {
        var endStr = day_of_week[this.endDate.getDay()] +
          ", " +
          this.endDate.getDate() +
          ". " +
          months[this.endDate.getMonth()] +
          " " +
          this.endDate.getFullYear();
        return startStr + " - " + endStr;
      }
      return startStr;
    },
    pointLocations() {
      var locations = [];

      for (let location of this.locations) {
        locations.push({
          id: location.id,
          location: {
            lat: parseFloat(location.data.lat),
            lng: parseFloat(location.data.lon),
          },
          weight: 100,
        });
      }
      return locations;
    },
  },
  methods: {
    dayBack() {
      this.date.setDate(this.date.getDate() - 1);
      this.date = new Date(this.date);
      if (this.endDate) {
        this.endDate.setDate(this.endDate.getDate() - 1);
        this.endDate = new Date(this.endDate);
      }

      this.updateUrl();
      this.load();
    },
    dayForward() {
      this.date.setDate(this.date.getDate() + 1);
      this.date = new Date(this.date);
      if (this.endDate) {
        this.endDate.setDate(this.endDate.getDate() + 1);
        this.endDate = new Date(this.endDate);
      }

      this.updateUrl();
      this.load();
    },
    async load() {
      this.resetView();
      var response;
      if (this.endDate) {
        response = await Location.getRange(this.programmatically_date, this.programmatically_end_date);
      } else {
        response = await Location.get(this.programmatically_date);
      }

      if (response.isOK) {
        if (response.data !== undefined) {
          this.locations = response.data;
          if (this.locations != undefined) {
            this.locations.forEach(
              function (location, index) {
                this.locations[index].items = [];
                this.path.push({
                  lat: parseFloat(location.data.lat),
                  lng: parseFloat(location.data.lon),
                });
              }.bind(this)
            );

            // Anomaly detection
            for (let i = 1; i < this.locations.length - 1; i++) {
              let prev = this.locations[i - 1];
              let curr = this.locations[i];
              let next = this.locations[i + 1];

              let distPrevCurr = this.getDistance(prev.data.lat, prev.data.lon, curr.data.lat, curr.data.lon);
              let distCurrNext = this.getDistance(curr.data.lat, curr.data.lon, next.data.lat, next.data.lon);
              let distPrevNext = this.getDistance(prev.data.lat, prev.data.lon, next.data.lat, next.data.lon);

              if (distPrevCurr > 100000 && distCurrNext > 100000 && distPrevNext < distPrevCurr) {
                curr.anomaly = true;
              }
            }

            var last_visible_index;
            this.locations.forEach(
              function (location, index) {
                if (index === 0) {
                  last_visible_index = 0;
                  return false;
                }

                var distance = this.getDistance(
                  location.data.lat,
                  location.data.lon,
                  this.locations[last_visible_index].data.lat,
                  this.locations[last_visible_index].data.lon
                );

                if (distance < 200) {
                  this.locations[index]["grouped"] = true;
                  this.locations[last_visible_index]["items"].push(
                    this.locations[index]
                  );
                } else {
                  last_visible_index = index;
                }
              }.bind(this)
            );

            this.locations_filtered = this.locations.filter(function (el) {
              return !el.grouped;
            });

            var dist = 0;
            for (let i = 1; i < this.locations.length; i++) {
              let prev = this.locations[i - 1];
              let curr = this.locations[i];
              if (!curr.anomaly && !prev.anomaly) {
                dist += this.getDistance(prev.data.lat, prev.data.lon, curr.data.lat, curr.data.lon);
              }
            }
            this.totalDistance = (dist / 1000).toFixed(2);
            
            let cityCounts = {};
            this.locations.forEach((loc) => {
              let address = loc.data.address;
              if (address) {
                let parts = address.split(',');
                let cityPart = parts.length > 1 ? parts[parts.length - 2].trim() : parts[0].trim();
                let city = cityPart.replace(/[0-9]/g, '').trim();
                if (city) {
                  if (!cityCounts[city]) cityCounts[city] = 0;
                  cityCounts[city]++;
                }
              }
            });
            
            let sortedCities = Object.keys(cityCounts).sort((a, b) => cityCounts[b] - cityCounts[a]);
            this.primaryCity = sortedCities.length > 0 ? sortedCities[0] : null;
            this.additionalCitiesCount = sortedCities.length > 1 ? sortedCities.length - 1 : 0;
            this.allCities = sortedCities.map(city => ({ name: city, count: cityCounts[city] }));

            this.path = new Array(this.path)[0];
            this.locations_group = new Array(this.locations_group)[0];
          }
        } else {
          this.locations = [];
        }
      }
      this.loaded = true;
    },
    openDateSelect() {
      if (this.endDate) {
        this.selectedDates = [this.programmatically_date, this.programmatically_end_date];
      } else {
        this.selectedDates = [this.programmatically_date];
      }
      this.d_date_select = true;
    },
    applyDateSelection() {
      if (!this.selectedDates || this.selectedDates.length === 0) return;
      
      let start = this.selectedDates[0];
      let end = this.selectedDates[1];
      
      if (this.selectedDates.length === 2) {
        let d1 = new Date(start);
        let d2 = new Date(end);
        if (d1 > d2) {
          let temp = start;
          start = end;
          end = temp;
        }
        this.date = new Date(start);
        this.endDate = new Date(end);
      } else {
        this.date = new Date(start);
        this.endDate = null;
      }
      
      this.d_date_select = false;
      this.updateUrl();
      this.load();
    },
    selectDate(date) {
      this.date = new Date(date);
      this.endDate = null;
      this.d_date_select = false;

      this.updateUrl();
      this.load();
    },
    updateUrl() {
      if (this.endDate) {
        if (this.$route.params.date !== this.programmatically_date || this.$route.params.enddate !== this.programmatically_end_date) {
          this.$router.replace('/timeline/' + this.programmatically_date + '/' + this.programmatically_end_date).catch(() => {});
        }
      } else {
        if (this.$route.params.date !== this.programmatically_date || this.$route.params.enddate !== undefined) {
          this.$router.replace('/timeline/' + this.programmatically_date).catch(() => {});
        }
      }
    },
    // Formatters
    allowedDates(val) {
      var date = new Date(val);
      return new Date() - date > 0;
    },
    getDistance(lat1, lon1, lat2, lon2) {
      const R = 6371e3; // metres
      const φ1 = (lat1 * Math.PI) / 180; // φ, λ in radians
      const φ2 = (lat2 * Math.PI) / 180;
      const Δφ = ((lat2 - lat1) * Math.PI) / 180;
      const Δλ = ((lon2 - lon1) * Math.PI) / 180;

      const a =
        Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      const d = R * c; // in metres
      return d;
    },
    getCenterFromCoordinates(coordinates) {
      var lats = 0,
        lngs = 0;
      coordinates.forEach(function (curr) {
        lats += curr.lat;
        lngs += curr.lng;
      });
      return { lat: lats / coordinates.length, lng: lngs / coordinates.length };
    },
    getZoomLevel(coordinates) {
      var GLOBE_WIDTH = 256;
      var pixelWidth = window.innerWidth / 3;
      var pixelHeight = 300;
      var west = 180,
        east = -180,
        north = 180,
        south = -180;
      coordinates.forEach(function (curr) {
        if (curr.lng < west) {
          west = curr.lng;
        }
        if (curr.lng > east) {
          east = curr.lng;
        }

        if (curr.lat < north) {
          north = curr.lat;
        }
        if (curr.lat > south) {
          south = curr.lat;
        }
      });
      var angle = east - west;
      if (angle < 0) {
        angle += 360;
      }

      var angle2 = south - north;
      if (angle2 < 0) {
        angle2 += 360;
      }

      return (
        Math.round(
          (Math.round(
            Math.log((pixelWidth * 360) / angle / GLOBE_WIDTH) / Math.LN2
          ) +
            Math.round(
              Math.log((pixelHeight * 360) / angle2 / GLOBE_WIDTH) / Math.LN2
            )) /
            2
        ) - 2
      );
    },
    resetView() {
      this.loaded = false;
      this.path = [];
      this.locations = [];
    },

    switchView() {
      if (this.currentView == "grouped") {
        this.currentView = "points";
      } else {
        this.currentView = "grouped";
      }

      window.localStorage.setItem("timeline_view", this.currentView);
    },
    
    async deleteDay() {
      if (confirm(this.$t("timeline.do_you_really_want_to_delete_this_day"))) {
        this.l_day_deletion = true;
        var response = await storage.get("locations", [
          {
            column: "date",
            operator: "==",
            value: this.programmatically_date,
          },
        ]);

        if (response.isOK) {
          var deleted_points = 0;
          response.data.forEach(
            async function (position) {
              var current_id = position.id;
              var delete_response = await storage.delete(
                "locations",
                current_id
              );
              if (delete_response.isOK) {
                deleted_points++;
                if (deleted_points === response.data.length) {
                  this.l_day_deletion = false;
                  Notifications.show(this.$t("timeline.notification.day_deleted"));
                  this.locations = [];
                  setTimeout(
                    function () {
                      this.load();
                    }.bind(this),
                    1000
                  );
                }
              } else {
                this.l_day_deletion = false;
                Notifications.show(
                  this.$t("timeline.notification.error_deleting_point")
                );
              }
            }.bind(this)
          );
        } else {
          this.l_day_deletion = false;
          Notifications.show(
            this.$t("timeline.notification.error_fetching_locations")
          );
        }
      }
    },
    async deletePoint(point) {
      if (confirm(this.$t("timeline.do_you_really_want_to_delete_this_point"))) {
        var delete_response = await storage.delete("locations", point.id);
        if (delete_response.isOK) {
          Notifications.show(this.$t("timeline.notification.point_deleted"));
          this.load();
        } else {
          Notifications.show(this.$t("timeline.notification.error_deleting_point"));
        }
      }
    },
    async retrieveMissingAddresses() {
      let missingAddressLocations = this.locations.filter(loc => !loc.data.address || loc.data.address.trim() === "-");
      if (missingAddressLocations.length === 0) {
        Notifications.show(this.$t("timeline.notification.no_missing_addresses_found"));
        return;
      }
      
      if (!confirm(this.$t("timeline.do_you_really_want_to_retrieve_missing_addresses"))) {
        return;
      }

      this.refetchProgress = { active: true, current: 0, total: missingAddressLocations.length };
      
      for (let loc of missingAddressLocations) {
        let delete_response = await storage.delete("locations", loc.id);
        if (delete_response.isOK) {
          await storage.insert("locations", loc.data);
        }
        this.refetchProgress.current++;
      }
      
      this.refetchProgress.active = false;
      Notifications.show(this.$t("timeline.notification.addresses_retrieved"));
      
      setTimeout(() => {
        this.load();
      }, 2000);
    },
    editPoint(point) {
      this.edit_location_item = point;
      this.edit_location_address = point.data.address;
      this.d_edit_location = true;
    },
    async saveLocationEdit() {
      var update_response = await storage.update("locations", this.edit_location_item.id, {
        address: this.edit_location_address
      });
      if (update_response.isOK) {
        Notifications.show(this.$t("timeline.notification.location_updated"));
        this.d_edit_location = false;
        this.load();
      } else {
        Notifications.show(this.$t("timeline.notification.error_updating_location"));
      }
    },
  },
  components: {
    PointGroup,
    PointSingle,
  },
};
</script>

<style>
.empty_map {
  height: 400px;
  width: calc(100% + 2 * 12px);
  margin: -12px;
  background: grey;
}

.timeline-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0;
}

.timeline-actions .v-btn {
  width: 100%;
}

@media (min-width: 600px) {
  .timeline-actions {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  .timeline-actions .v-btn {
    width: auto;
  }
}
</style>
